import React from 'react'
import LanguageSwitcher from './LanguageSwitcher'
import ThemeToggle from 'theme/ThemeToggle'

export default function InterfacePreferences({ placement = '' }) {
  return <div className={`erp-interface-preferences ${placement ? 'erp-' + placement + '-preferences' : ''}`}>
    <LanguageSwitcher /><ThemeToggle compact />
  </div>
}
